import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App as AppNativa } from '@capacitor/app';
import { PushNotifications } from '@capacitor/push-notifications';
import { useAuth } from '../context/AuthContext';
import { esApp } from '../utils/plataforma';
import { refrescarToken } from '../utils/notificaciones';

/**
 * Lo que llega a la app de iOS desde fuera. En la web no hace nada.
 *
 * - Un enlace de la web (por ejemplo una invitación a un plan de A medias que
 *   llega por WhatsApp) abre la app en vez de Safari (Universal Links): se
 *   lleva a esa misma ruta dentro de la app.
 * - Los Atajos y la automatización de Wallet abren myarinn://apuntar?… (o
 *   https://myarinn.app/apuntar?…): myarinn://ruta va a /ruta.
 * - Tocar una notificación abre la ruta que trae (el plan del recordatorio).
 * - Al entrar, si las notificaciones están activadas, se refresca el token.
 */
export const EnlacesEntrantes: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!esApp) return;
    const enlace = AppNativa.addListener('appUrlOpen', ({ url }) => {
      try {
        const { protocol, host, pathname, search, hash } = new URL(url);
        // En myarinn://apuntar, «apuntar» es el host de la URL, no la ruta
        const ruta = protocol === 'myarinn:' ? `/${host}${pathname}` : pathname;
        if (ruta && ruta !== '/') navigate(ruta + search + hash);
      } catch { /* URL rara: se ignora */ }
    });
    const toque = PushNotifications.addListener('pushNotificationActionPerformed', ({ notification }) => {
      const ruta = notification.data?.ruta;
      if (typeof ruta === 'string' && ruta.startsWith('/')) navigate(ruta);
    });
    return () => {
      enlace.then(e => e.remove());
      toque.then(e => e.remove());
    };
  }, [navigate]);

  useEffect(() => {
    if (esApp && user) refrescarToken(user.uid).catch(e => console.warn('Token de notificaciones', e));
  }, [user]);

  return null;
};
